type BrowserLocation = Readonly<{
  pathname: string;
  search: string;
  hash: string;
}>;

/**
 * The bundle is built for a base path (for example `/budget/`), and the router
 * only renders routes under it. Opening the host root or a route without the
 * prefix would show an empty page, so work out where the user should land.
 * Returns null when the URL is already under the base path (or there is none).
 */
export function getBasePathRedirect(
  location: BrowserLocation,
  basePath: string,
): string | null {
  // No prefix, or a relative base (desktop builds): nothing to enforce.
  if (!basePath.startsWith('/') || basePath === '/') {
    return null;
  }
  const base = basePath.endsWith('/') ? basePath : `${basePath}/`;
  const { pathname, search, hash } = location;

  if (pathname === base.slice(0, -1)) {
    return `${base}${search}${hash}`;
  }
  if (pathname.startsWith(base)) {
    return null;
  }
  return `${base}${pathname.replace(/^\/+/, '')}${search}${hash}`;
}
